import { z } from 'zod'
import { fromZodError } from 'zod-validation-error'

import { makeServerResponseSchema } from '../../../utils/schema'
import { client } from '../../../services/client'
import { groupRoiGoalSchema, salesGoalSchema } from './stats.schema'

async function fetchRoiGroupsGoal() {
  const response = await client.post('functions/getRoiGroupsGoal').json()

  const parsedResponse = makeServerResponseSchema(
    z.object({ data: z.array(groupRoiGoalSchema) })
  ).safeParse(response)

  if (!parsedResponse.success)
    throw new Error(fromZodError(parsedResponse.error).message)

  return parsedResponse.data.result
}

async function fetchUserGoalSalesMonth() {
  const response = await client.post('functions/getUserGoalSalesMonth').json()

  const parsedResponse =
    makeServerResponseSchema(salesGoalSchema).safeParse(response)

  if (!parsedResponse.success)
    throw new Error(fromZodError(parsedResponse.error).message)

  return parsedResponse.data.result
}

async function fetchUserGoalSalesWeek() {
  const response = await client.post('functions/getUserGoalSalesWeek').json()

  const parsedResponse =
    makeServerResponseSchema(salesGoalSchema).safeParse(response)

  if (!parsedResponse.success)
    throw new Error(fromZodError(parsedResponse.error).message)

  return parsedResponse.data.result
}

export { fetchRoiGroupsGoal, fetchUserGoalSalesMonth, fetchUserGoalSalesWeek }
